import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";

import { cn } from "@/lib/utils";

const sizeClasses = {
  "2xs": "h-2.5 w-2.5",   // ~10px – filter listák, sűrű sorok
  xs: "h-3 w-3",          // ~12px
  sm: "h-3.5 w-3.5",      // ~14px
  default: "h-4 w-4",     // ~16px
} as const;

const iconSizes = {
  "2xs": "h-1.5 w-1.5",
  xs: "h-2 w-2",
  sm: "h-2.5 w-2.5",
  default: "h-4 w-4",
} as const;

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & { size?: keyof typeof sizeClasses }
>(({ className, size = "default", ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
      sizeClasses[size],
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className="flex items-center justify-center text-current"
    >
      <Check className={cn("shrink-0", iconSizes[size])} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
